<div class="farmy">

  <section class="farmy-hero">
    <img class="farmy-hero__avatar" src="assets/farmy.png" alt="Farmy">
    <div class="farmy-hero__main">
      <h1 class="stk-page-title">Farmy <span class="farmy-hero__tag">gyártásmérnök</span></h1>
      <div class="stk-page-sub">A gyártásért felel: látja a készletet és a beérkezett rendeléseket az ERP-ben, és ebből gyártási tervet állít össze és indít a Printers Line-ban. A műhelyi mini PC-n dolgozik, a nyomtatófarm mellett. Írj neki a chatben (privátban, vagy a Fő chatben „&#64;Farmy”).</div>
      <div class="farmy-hero__status" *ngIf="data">
        <span class="stk-pill" [ngClass]="data.enabled && data.workerOnline ? 'stk-pill--green' : 'stk-pill--yellow'">{{ workerLabel }}</span>
        <span class="farmy-hero__seen" *ngIf="data.workerSeenAt && !data.workerOnline">utoljára: {{ data.workerSeenAt | date:'MMM d., HH:mm' }}</span>
        <label class="farmy-switch" [title]="data.enabled ? 'Kikapcsolás' : 'Bekapcsolás'">
          <input type="checkbox" [checked]="data.enabled" (change)="toggleEnabled()">
          <span></span>
        </label>
      </div>
    </div>
    <a class="stk-btn stk-btn--accent farmy-hero__cta" *ngIf="chatLink" [routerLink]="chatLink">Írj Farmynak 💬</a>
  </section>

  <div class="farmy-empty" *ngIf="loading && !data">Betöltés…</div>
  <div class="farmy-empty" *ngIf="loadFailed">Farmy adatai most nem érhetők el.</div>

  <ng-container *ngIf="data">
    <section class="farmy-card farmy-card--proposals" *ngIf="data.proposals.length">
      <h2 class="stk-section-title">Farmy javasolja, hogy jegyezze meg <span class="farmy-count">{{ data.proposals.length }}</span></h2>
      <div class="farmy-help">Ezek akkor kerülnek a tudástárba, ha jóváhagyod. Előtte átírhatod őket.</div>
      <div class="farmy-item" *ngFor="let p of data.proposals">
        <ng-container *ngIf="editing[p.id] === undefined; else editProposal">
          <div class="farmy-item__text">{{ p.text }}</div>
          <div class="farmy-item__actions">
            <button type="button" class="stk-btn stk-btn--accent farmy-btn" [disabled]="saving" (click)="save(p.id, true)">Jóváhagyom</button>
            <button type="button" class="stk-btn stk-btn--ghost farmy-btn" (click)="startEdit(p)">Átírom</button>
            <button type="button" class="stk-icon-btn" title="Elvetem" (click)="remove(p.id, 'Elveted Farmy javaslatát?')">✕</button>
          </div>
        </ng-container>
        <ng-template #editProposal>
          <textarea class="farmy-textarea" rows="3" [(ngModel)]="editing[p.id]"></textarea>
          <div class="farmy-item__actions">
            <button type="button" class="stk-btn stk-btn--accent farmy-btn" [disabled]="saving" (click)="save(p.id, true)">Mentés és jóváhagyás</button>
            <button type="button" class="stk-btn stk-btn--ghost farmy-btn" (click)="cancelEdit(p.id)">Mégse</button>
          </div>
        </ng-template>
      </div>
    </section>

    <section class="farmy-card">
      <h2 class="stk-section-title">Tudástár <span class="farmy-count">{{ data.knowledge.length }}</span></h2>
      <div class="farmy-help">Amit itt leírsz, azt Farmy minden beszélgetésben figyelembe veszi: gyártási napok, minimum készletek, prioritások, tiltások. Egy bejegyzés legyen egy téma.</div>

      <div class="farmy-add">
        <textarea class="farmy-textarea" rows="3" [(ngModel)]="draft" placeholder="Pl. Hétvégén ne indíts új gyártási tervet, csak ha SOS rendelés van."></textarea>
        <div class="farmy-add__bar">
          <div class="farmy-examples">
            <button type="button" class="farmy-example" *ngFor="let ex of examples" (click)="useExample(ex)">+ {{ ex }}</button>
          </div>
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="!draft.trim() || saving" (click)="add()">Jegyezd meg</button>
        </div>
      </div>

      <div class="farmy-help" *ngIf="!data.knowledge.length">Még üres. Kezdd a gyártási napokkal és a minimum készletekkel.</div>
      <div class="farmy-item" *ngFor="let k of data.knowledge">
        <ng-container *ngIf="editing[k.id] === undefined; else editKnowledge">
          <div class="farmy-item__text">{{ k.text }}</div>
          <div class="farmy-item__meta">{{ k.createdBy || '—' }} · {{ (k.updatedAt || k.createdAt) | date:'yyyy. MMM d.' }}</div>
          <div class="farmy-item__actions">
            <button type="button" class="stk-btn stk-btn--ghost farmy-btn" (click)="startEdit(k)">Szerkesztés</button>
            <button type="button" class="stk-icon-btn" title="Törlés" (click)="remove(k.id)">✕</button>
          </div>
        </ng-container>
        <ng-template #editKnowledge>
          <textarea class="farmy-textarea" rows="4" [(ngModel)]="editing[k.id]"></textarea>
          <div class="farmy-item__actions">
            <button type="button" class="stk-btn stk-btn--accent farmy-btn" [disabled]="saving || !editing[k.id].trim()" (click)="save(k.id)">Mentés</button>
            <button type="button" class="stk-btn stk-btn--ghost farmy-btn" (click)="cancelEdit(k.id)">Mégse</button>
          </div>
        </ng-template>
      </div>
    </section>

    <section class="farmy-card">
      <h2 class="stk-section-title">Legutóbbi munkák</h2>
      <div class="farmy-help" *ngIf="!data.jobs.length">Még nem dolgozott. Írj neki a chatben!</div>
      <div class="farmy-job" *ngFor="let j of data.jobs" (click)="expanded[j.id] = !expanded[j.id]">
        <div class="farmy-job__top">
          <span class="farmy-job__status farmy-job__status--{{ j.status }}">{{ statusLabel[j.status] }}</span>
          <span class="farmy-job__who">{{ j.requestedBy || 'Ismeretlen' }}</span>
          <span class="farmy-job__when">{{ j.createdAt | date:'MMM d., HH:mm' }}</span>
        </div>
        <div class="farmy-job__text" *ngIf="expanded[j.id] && (j.summary || j.error)">{{ j.error || j.summary }}</div>
      </div>
    </section>
  </ng-container>
</div>
